<template>
  <ValidationObserver ref="observerBooking">
    <b-card>
      <div v-for="(guest, index) in guests" :key="guest.idForm">
        <div>
          <h5>{{cardTitle({guest, index})}}</h5>
          <label v-if="!guest.Adult">Edad: {{guest.Age}}</label>
          <div class="d-flex justify-content-between" v-if="guest.mainGuest">
            <label>Adulto 1</label>           
          </div>
        </div>
          <b-row>
            <b-col v-if="guest.mainGuest">
              
              <ValidationProvider name="Prefijo" rules="required">
                <b-form-group label="Prefijo" slot-scope="{ valid, errors }">
                  <b-form-select
                    :state="errors[0] ? false : valid ? true : null"
                    v-model="guest.NamePrefix"
                    @input="setDataInBooking(guests)"
                  >
                    <option value="">Seleccione una opción</option>
                    <option
                      v-for="(namesF, index) in namesPrefix"
                      :key="index"
                      :value="namesF.value"
                    >
                      {{ namesF.text }}
                    </option>
                  </b-form-select>
                  <b-form-invalid-feedback
                    >{{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col>
              <ValidationProvider rules="required" name="Nombre">
                <b-form-group label="Nombre" slot-scope="{ valid, errors }">
                  <b-form-input
                    type="text"
                    v-model="guest.GivenName"
                    :state="errors[0] ? false : valid ? true : null"
                    @input="setDataInBooking(guests)"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col>
              <ValidationProvider rules="required" name="Apellido">
                <b-form-group label="Apellido" slot-scope="{ valid, errors }">
                  <b-form-input
                    type="text"
                    v-model="guest.Surname"
                    :state="errors[0] ? false : valid ? true : null"
                    @input="setDataInBooking(guests)"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>

          <b-row v-if="guest.Adult && guest.mainGuest">
            <b-col>
              <ValidationProvider rules="required" name="Teléfono">
                <b-form-group
                  label="Teléfono"
                  slot-scope="{ valid, errors }"
                >
                  <b-form-input
                    type="number"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    v-model="guest.PhoneNumber"
                    maxlength="10"
                    :state="errors[0] ? false : valid ? true : null"
                    @input="setDataInBooking(guests)"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col>
              <ValidationProvider rules="required|email" name="Email">
                <b-form-group label="Email" slot-scope="{ valid, errors }">
                  <b-form-input
                    type="email"
                    v-model="guest.Email"
                    :state="errors[0] ? false : valid ? true : null"
                    @input="setDataInBooking(guests)"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>

          <b-row v-if="guest.mainGuest">
            <b-col md="6">          
              <ValidationProvider
                name="País"              
                v-slot="{ errors, valid, dirty, validate }"
                :rules="guest.mainGuest ? 'required' : ''"
              >
                <b-form-group
                  label="País"
                  :state="!errors.length ? (dirty ? true : null) : false"
                >
                  <v-select
                    class="custom-v-select"
                    :options="countryOptions"     
                    label="label"
                    track-by="countryCode"
                    :reduce="opt => String(opt.value)"  
                    v-model="guest.country"
                    :class="{ 'is-invalid': errors.length, 'is-valid': valid && dirty }"
                    @option:selected="onCountrySelected(guest, $event)" 
                    @input="(v)=>{ onCountryInput(guest, v); setDataInBooking(guests); validate(); }"
                    @search:blur="validate"
                    @blur.native="validate"
                  />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
              <input type="hidden" v-model="guest.countryCode">

            </b-col>
            <b-col md="6" v-if="showInputNationality">              
              <ValidationProvider :rules="guest.mainGuest ? 'required' : ''"  name="Nacionalidad">
                <b-form-group label="Nacionalidad" slot-scope="{ valid, errors }">
                  <b-form-input
                    type="text"
                    v-model="guest.nacionality"
                    :state="errors[0] ? false : valid ? true : null"
                    @input="setDataInBooking(guests)"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col  md="6">              
              <ValidationProvider :rules="guest.mainGuest ? 'required' : ''"  name="Ciudad">
                <b-form-group label="Ciudad" slot-scope="{ valid, errors }">
                  <b-form-input
                    type="text"
                    v-model="guest.city"
                    :state="errors[0] ? false : valid ? true : null"
                    @input="setDataInBooking(guests)"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            
          </b-row>
       

          <hr v-if="((index+1) < guests.length)">
      </div>
    </b-card>
  </ValidationObserver>
</template>

<script>
import { namesPrefix } from '@/data/data'
import vSelect from "vue-select"
import { mapState } from 'vuex'

export default {
  props: {
    guests: {
      type: Array,
      required: true,
    },
  },
  components: {
    vSelect
  },
  data(){
    return {
      namesPrefix,
      childages: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17]
    }
  },
  mounted() {    
    (this.guests || []).forEach(g => this.syncCountryCodeIfNeeded(g))
  },
  computed:{
    ...mapState('start',['countries','showInputNationality']),
    countryOptions() {
      return this.countries.map(c => ({
        label: c.displayES,
        value: String(c.name),
        countryCode : c.code, 
      }))
    },
    mainGuest() {
      return this.guests.find(g => g.mainGuest) || null
    },        
  },
  methods: {
    setDataInBooking(data){
      this.$emit('set-guests-in-properties', data)
    }, 
    onCountrySelected(guest, opt) {
      guest.countryCode = opt?.countryCode ?? null
    },

    onCountryInput(guest, val) {
      // si limpian el select (val === null o ''), limpiar countryCode
      if (val == null || val === '') guest.countryCode = null
    },
    syncCountryCodeIfNeeded(guest){
      if (guest?.country && !guest?.countryCode) {
        const found = this.countries.find(
          c => String(c.name) === String(guest.country)
        )
        guest.countryCode = found?.code ?? null
      }
    },
       
    cardTitle(data){
      const {guest, index} = data
      if (guest.mainGuest) return `Main Guest: ${guest.GivenName} ${guest.Surname}`
      else return guest.Adult ? `Adulto ${index+1}: ${guest.GivenName} ${guest.Surname}` : `Niño ${index+1}: ${guest.GivenName} ${guest.Surname}`
    }
  }
}
</script>

